import React, { useState, useEffect, useRef } from "react";
import { Link } from "gatsby";
import LogoSprite from "./LogoSprite";
import DrawerWithForm from "./Drawer";
import { PhoneArrowUpRightIcon } from "@heroicons/react/24/solid";
import { ChatBubbleLeftIcon } from "@heroicons/react/24/outline";
import useMatomoEvent from "./hooks/useMatomoEvent";

const Header = ({ location, uptitle, title, phone }) => {
  const [hideHeader, setHideHeader] = useState(false);
  const [atTop, setAtTop] = useState(true);
  const lastScrollY = useRef(0);
  const ticking = useRef(false);
  const trackEvent = useMatomoEvent();

  useEffect(() => {
    const handleScroll = () => {
      const currentScrollY =
        window.pageYoffSet || document.documentElement.scrollTop;
      if (!ticking.current) {
        window.requestAnimationFrame(() => {
          setAtTop(currentScrollY === 0);
          // Si se hace scroll hacia abajo (y superamos 50px) se oculta el segundo div.
          if (currentScrollY > lastScrollY.current && currentScrollY > 50) {
            setHideHeader(true);
          } else {
            setHideHeader(false);
          }
          lastScrollY.current = currentScrollY;
          ticking.current = false;
        });
        ticking.current = true;
      }
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  // Definimos el padding del segundo div según si estamos en la parte superior o no.
  const secondDivClasses =
    !atTop && location === "contact"
      ? "hidden"
      : atTop
      ? "py-4 md:py-8 bg-white"
      : "py-3 md:py-4 bg-slate-100";

  const phoneLinkClasses = atTop ? "md:hidden" : "";

  return (
    <header className="mb-6 sticky top-0 z-50 transition-all duration-300">
      {/* Primer div: desaparece sutilmente al hacer scroll */}
      <div
        className={`overflow-hidden transition-all duration-300 ${
          atTop ? "max-h-20 opacity-100" : "max-h-0 opacity-0"
        }`}
      >
        <div className="py-3 bg-slate-100 text-xs">
          <div className="container md:flex justify-between text-center md:text-left">
            <strong className="font-normal">
              Empresa de{" "}
              {location === "home" ||
              location === "thank-you" ||
              location === "legal"
                ? "Cerramientos en Madrid"
                : location === "zona"
                ? title
                : title.includes("en Madrid")
                ? title
                : `${title} en Madrid`}
            </strong>
            <a
              href={`tel:+34${phone.replace(/\s+/g, "")}`}
              className="hidden md:flex items-center gap-1 font-semibold"
              data-splitbee-event="Teléfono Top Header"
              data-splitbee-event-type="Clic"
              onClick={() => {
                const pagePath = window.location.pathname;
                trackEvent("Teléfono", "Clic en Top Header", pagePath);
              }}
            >
              <ChatBubbleLeftIcon className="size-4 stroke-slate-400" />
              {`+34 ${phone}`}
              <span className="absolute normal-case top-full md:w-full left-1/2 -translate-x-1/2 mt-1 px-3 py-2 rounded text-xs font-light text-white bg-slate-700 opacity-0 group-hover:opacity-100 transition-all duration-200 text-center">
                Presupuesto sin compromiso
                <span className="absolute top-0 left-1/2 -translate-x-1/2 -translate-y-full w-0 h-0 border-l-8 border-r-8 border-b-8 border-transparent border-b-slate-700" />
              </span>
            </a>
          </div>
        </div>
      </div>
      {/* Segundo div: cambia de padding y se desliza según el scroll */}
      <div
        className={`transition-all duration-300 ${secondDivClasses} ${
          hideHeader ? "-translate-y-full" : ""
        }`}
      >
        <div className="container flex items-center justify-between">
          <Link to="/">
            <LogoSprite
              id="logo"
              className=" w-40 aspect-[283/113] hidden md:block"
            />
            <LogoSprite id="imago" className="size-12 md:hidden" />
            <span className="sr-only">Cerramientos Proyectop</span>
          </Link>
          <div className="flex gap-4 md:gap-6 items-center">
            <a
              href={`tel:+34${phone.replace(/\s+/g, "")}`}
              className={`relative group flex items-center justify-center font-semibold text-lg text-blue-500 hover:text-blue-400 ${phoneLinkClasses}`}
              data-splitbee-event={`Teléfono Header${
                !atTop ? ": When Sticky" : ""
              }`}
              data-splitbee-event-type="Clic"
              onClick={() => {
                const pagePath = window.location.pathname;
                trackEvent(
                  "Teléfono",
                  "Clic en Header",
                  `Header${!atTop ? ": When Sticky" : ""} - ${pagePath}`
                );
              }}
            >
              <PhoneArrowUpRightIcon className="size-7" />
              <span className="absolute block normal-case font-semibold top-full  left-1/2 -translate-x-1/2 mt-1 px-3 py-2 rounded text-xs text-white bg-blue-700 opacity-0 group-hover:opacity-100 transition-all duration-200 shadow text-center">
                Ll&aacute;manos
                <span className="absolute top-0 left-1/2 -translate-x-1/2 -translate-y-full w-0 h-0 border-l-8 border-r-8 border-b-8 border-transparent border-b-blue-700" />
              </span>
            </a>
            <DrawerWithForm
              municipioInicial={location === "zona" ? uptitle : ""}
            />
          </div>
        </div>
      </div>
    </header>
  );
};

export default Header;
